const firebaseConfig = {
	apiKey: 'AIzaSyBblp7WKAUZO8E_CcoTKoA0IXo13qTpvvI',
	authDomain: 'mirpurgrocery-4c437.firebaseapp.com',
	projectId: 'mirpurgrocery-4c437',
	storageBucket: 'mirpurgrocery-4c437.appspot.com',
	messagingSenderId: '644379181143',
	appId: '1:644379181143:web:3057a2f1fe987eb96a2312',
};
export default firebaseConfig;
